<template>
  <svg :height="size" :width="size" viewBox="0 0 50 50" class="spinner" v-on="$listeners">
    <circle cx="50%" cy="50%" r="40%" fill="none" stroke-width="10%" :stroke="color"/>
  </svg>
</template>


<script>
export default {
  name: 'IconSpinner',

  props: {
    size: {
      type: String,
      default: '1em',
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>


<style lang="scss" scoped>
svg {
  animation: rotate 2s linear infinite;
  circle {
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
</style>